export default "__VITE_ASSET__DuX3afte__"